import {useDictAll} from '../../../Utils/Hooks/useDict';

export function useDict() {
    return useDictAll([
        'ServiceVersion',
        'RegBy',
        'ServiceTime',
        'ScenarioType',
        'RegType',
        'Switch',
        'ServiceStatus',
        'TenantType',
        'TenantStatus',
        'MenuType',
        'Status',
        'IconType',
        'H5ShowType',
    ]);
}
